import merge  from 'deepmerge'
import katex from 'katex'
//import { renderMathInElement } from 'katex/dist/contrib/auto-render'; // 引入auto-render
import renderMathInElement from './auto-render'

// katex渲染指令
var katexDirective = function (cmdOptions) {
  return {
    name: "katex",
    directive: function (element, kDirectiveOpParams) {
      var mergedOptions1 = kDirectiveOpParams.value && kDirectiveOpParams.value.options || {}
          , mergedOptions2 = merge(cmdOptions, mergedOptions1);
      if (kDirectiveOpParams.arg && kDirectiveOpParams.arg === "auto")
        renderMathInElement(element, mergedOptions2);
      else {
        var katexExpression = kDirectiveOpParams.value.expression || kDirectiveOpParams.value
            , displayParams = {};
        if (kDirectiveOpParams.arg === "display")
          displayParams.displayMode = !0;
        var mergedOptions3 = merge(mergedOptions2, displayParams);
        katex.render(katexExpression, element, mergedOptions3)
      }
    }
  }
}
export default katexDirective